export const environment = {
    apiBaseUrl: 'https://app.homolog.smartkaizen.com.br/api/v1',
    googleClientId: '279613794178-op56obsce7btdnt4fg9h1qrrj5eqtapr.apps.googleusercontent.com'
};
